import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DoctorDataModel} from '../../../../../models/doctors/doctor-data.model';

@Component({
  selector: 'app-doctor-configuration-after-save-warning-dialog',
  templateUrl: './doctor-configuration-after-save-warning-dialog.component.html',
  styleUrls: ['./doctor-configuration-after-save-warning-dialog.component.scss']
})
export class DoctorConfigurationAfterSaveWarningDialogComponent implements OnInit {
  isNoLocations: boolean;
  isNoLicenses: boolean;

  constructor(private dialogRef: MatDialogRef<DoctorConfigurationAfterSaveWarningDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: DoctorDataModel) {
    this.isNoLocations = data.dataDoctorLocations.length === 0;
    this.isNoLicenses = data.dataDoctorLicences.length === 0;
    //
  }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close();
  }
}
